module.exports = __webpack_public_path__ + "img/copy-dark.89165533.svg";